"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RATING = void 0;
const RATING = exports.RATING = 'rating';
